import { render, staticRenderFns } from "./Prealert.vue?vue&type=template&id=e90df3ba&scoped=true&"
import script from "./Prealert.vue?vue&type=script&lang=js&"
export * from "./Prealert.vue?vue&type=script&lang=js&"
import style0 from "./Prealert.vue?vue&type=style&index=0&id=e90df3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90df3ba",
  null
  
)

export default component.exports